import './App.scss';
import { cookie } from '@mvecom/common/utils/clientCookieManager';
import { stringToBoolean } from '@mvecom/common/utils/stringToBoolean';
import { useContext, useEffect, useState } from 'react';

import { Actions } from './actions/enums';
import { LoginModal } from './components/Modals/LoginModal/LoginModal';
import { MvAgentCart } from './components/MvAgentCart/MvAgentCart';
import { MvAgentFavourites } from './components/MvAgentFavourites/MvAgentFavourites';
import { useLogoutBusinessCustomer } from './hooks/useLogoutBusinessCustomer';
import { getCookieDomain } from './network/utils/getCookieDomain';
import { getRetailUnitAndLanguage } from './network/utils/getRetailUnitAndLanguage';
import { TranslationsContext, TranslationsState } from './providers/TranslationsProvider';

const App = () => {
  const { translationsState, getTranslations } = useContext(TranslationsContext);
  const [loaded, setLoaded] = useState<Array<'cart' | 'favourites'>>([]);

  useLogoutBusinessCustomer();

  useEffect(() => {
    getTranslations();
  }, [getTranslations]);

  useEffect(() => {
    // Only used for CIAM
    if (loaded.includes('cart') && loaded.includes('favourites')) {
      if (stringToBoolean(cookie.get('auth0-logged-in'))) {
        cookie.del('auth0-logged-in', `/${getRetailUnitAndLanguage().retailUnit}`, getCookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_IN);
      }
      if (stringToBoolean(cookie.get('auth0-logged-out'))) {
        cookie.del('auth0-logged-out', `/${getRetailUnitAndLanguage().retailUnit}`, getCookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_OUT);
      }
    }
  }, [loaded]);

  useEffect(() => {
    const agentLoaded = (agent: 'cart' | 'favourites') => () => {
      setLoaded((v) => [...v, agent]);
    };

    globalThis.ikea.pubsub.subscribe(Actions.CART_AGENT_LOADED, agentLoaded('cart'));
    globalThis.ikea.pubsub.subscribe(Actions.FAVOURITES_AGENT_LOADED, agentLoaded('favourites'));
  }, []);

  return (
    <>
      {translationsState === TranslationsState.DONE && (
        <>
          {import.meta.env.DEV && (
            <link rel="stylesheet" href="https://www.ikea.com/global/assets/fonts/en/fonts.css"></link>
          )}
          <MvAgentCart />
          <MvAgentFavourites />
          <LoginModal />
        </>
      )}
    </>
  );
};

export default App;
